import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './CookieConsent.css';

const COOKIE_CONSENT_KEY = 'cookieConsent';

const CookieConsent: React.FC = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-consent-content">
        <p>
          {t('cookies.message')}{' '}
          <Link to="/privacy-policy">{t('cookies.learnMore')}</Link>
        </p>
        <div className="cookie-consent-buttons">
          <button className="cookie-btn decline" onClick={handleDecline}>
            {t('cookies.decline')}
          </button>
          <button className="cookie-btn accept" onClick={handleAccept}>
            {t('cookies.accept')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
